// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-group-item {
  border: 1px solid #e9eaf0;
  border-radius: 8px;
  margin-bottom: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
}

.user-management-back-button {
  font-size: 16px;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -0.008em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #564ffd;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.class-details {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #1d2026;
  margin-bottom: 4px;
}

.class-details-light {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #8c94a3;
}

.play-button {
  text-decoration: none !important;
  color: #ff6636 !important;
  display: flex !important;
  gap: 10px !important;
  align-items: center !important;
  margin-top: 8px;
}

.nav-tabs {
  gap: 10px;
  padding: 0 10px;
  border-bottom: 0 !important;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  white-space: nowrap;
}
.nav-tabs::-webkit-scrollbar {
  display: none;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #ff6636 !important;
  border: 0.5px solid;
  border-radius: 44px;
  border-color: #ff6636 !important;
  background-color: #fff;
}

.nav-tabs .nav-link {
  border: 0.5px solid !important;
  border-radius: 44px !important;
  color: #8c94a3 !important;
  background-color: #f8f9fa;
  padding: 8px 16px;
  margin-bottom: 0 !important;
}

@media (min-width: 1024px) {
  .list-group-item {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .play-button {
    margin-top: 0;
  }
  .class-details,
  .class-details-light {
    font-size: 14px;
    line-height: 22px;
  }
}
/* Media query for screens smaller than 408px */
@media (max-width: 408px) {
  .trouble-spot-name {
    padding: 8px;
    font-size: 12px;
  }
  .class-details {
    font-size: 10px;
    line-height: 18px;
  }
  .class-details-light {
    font-size: 10px;
    line-height: 16px;
  }
  .nav-tabs .nav-link {
    padding: 6px 12px;
    font-size: 12px;
  }
  .play-button {
    font-size: 12px;
  }
}
/* Media query for screens smaller than 370px */
@media (max-width: 370px) {
  .trouble-spot-name {
    padding: 6px;
    font-size: 10px;
  }
  .class-details {
    font-size: 8px;
    line-height: 16px;
  }
  .class-details-light {
    font-size: 7px;
    line-height: 14px;
  }
  .nav-tabs .nav-link {
    padding: 4px 8px;
    font-size: 10px;
  }
  .play-button {
    font-size: 10px;
  }
}
.page-break {
  page-break-before: always;
  break-before: page;
}

.filter-buttons {
  display: flex;
  justify-content: center;
  padding: 0 1rem;
}
.filter-buttons .filter-btn {
  padding: 8px 16px;
  border: 1px solid #e0e0e0;
  background: white;
  color: #6c757d;
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: pointer;
}
.filter-buttons .filter-btn:first-child {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.filter-buttons .filter-btn:last-child {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.filter-buttons .filter-btn:not(:last-child) {
  border-right: none;
}
.filter-buttons .filter-btn.active {
  background: #564ffd;
  color: white;
  border-color: #564ffd;
}
.filter-buttons .filter-btn:hover:not(.active) {
  background: #f8f9fa;
}

.exam-attempts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  padding: 1rem;
}
.exam-attempts-grid .no-results-message {
  grid-column: 1/-1;
  text-align: center;
  padding: 3rem 1rem;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px dashed #dee2e6;
}
.exam-attempts-grid .no-results-message h4 {
  color: #2c3e50;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.exam-attempts-grid .no-results-message p {
  color: #6c757d;
  font-size: 1rem;
  margin: 0;
}

.exam-attempt-card {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  background: white;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.exam-attempt-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.exam-attempt-card .card-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1.25rem;
}
.exam-attempt-card .exam-title-container {
  flex: 1 1;
  min-width: 0;
}
.exam-attempt-card .exam-title-container .card-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.exam-attempt-card .exam-stats {
  display: flex;
  gap: 1rem;
  flex-shrink: 0;
}
.exam-attempt-card .exam-stats .stat-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.exam-attempt-card .exam-stats .stat-item svg {
  font-size: 1.2rem;
}
.exam-attempt-card .exam-stats .stat-item span {
  font-weight: 500;
  color: #2c3e50;
}
.exam-attempt-card .exam-details {
  display: flex;
  gap: 1.5rem;
  margin-top: 1rem;
  color: #6c757d;
  font-size: 0.9rem;
  flex-shrink: 0;
}
.exam-attempt-card .exam-details .detail-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}
.exam-attempt-card .exam-details .detail-item svg {
  font-size: 1rem;
  flex-shrink: 0;
}
.exam-attempt-card .exam-details .detail-item span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.exam-attempt-card .progress {
  background-color: #f8f9fa;
  border-radius: 3px;
  overflow: hidden;
  flex-shrink: 0;
}
.exam-attempt-card .progress-bar {
  transition: width 0.6s ease;
}
.exam-attempt-card .mt-3.w-100 {
  margin-top: auto;
}

@media (max-width: 1024px) {
  .filter-buttons {
    overflow-x: auto;
    padding: 0 0.5rem;
    -webkit-overflow-scrolling: touch;
  }
  .filter-buttons::-webkit-scrollbar {
    display: none;
  }
  .filter-buttons .filter-btn {
    padding: 6px 12px;
    font-size: 0.9rem;
    white-space: nowrap;
  }
}
.topic-scores-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  max-height: 400px;
  overflow-y: auto;
}

.topic-score-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.topic-score-row:hover {
  background-color: #e9ecef;
}

.topic-name {
  font-weight: 500;
  color: #495057;
}

.topic-score {
  font-weight: 600;
  color: #0d6efd;
  min-width: 60px;
  text-align: right;
}

.excel-grid {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
  max-height: 500px;
  overflow-y: auto;
}

.grid-header {
  display: grid;
  grid-template-columns: 2fr 1fr;
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  position: sticky;
  top: 0;
  z-index: 1;
}

.grid-row {
  display: grid;
  grid-template-columns: 2fr 1fr;
  border-bottom: 1px solid #dee2e6;
  transition: background-color 0.2s;
}
.grid-row:hover {
  background-color: #f8f9fa;
}
.grid-row:last-child {
  border-bottom: none;
}

.grid-cell {
  padding: 12px 16px;
  font-size: 14px;
  color: #495057;
  border-right: 1px solid #dee2e6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.grid-cell:last-child {
  border-right: none;
  text-align: right;
  font-weight: 500;
}

.grid-header .grid-cell {
  font-weight: 600;
  color: #212529;
  background-color: #f8f9fa;
}

.grid-cell.clickable {
  cursor: pointer;
  color: #0d6efd;
}
.grid-cell.clickable:hover {
  background-color: #f8f9fa;
}

.practice-sets-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 0.5rem;
}
.practice-sets-list::-webkit-scrollbar {
  width: 6px;
}
.practice-sets-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.practice-sets-list::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.practice-set-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  transition: background-color 0.2s;
  min-height: 80px;
}
.practice-set-item:hover {
  background-color: #e9ecef;
}

.practice-set-info {
  flex: 1 1;
  min-width: 0;
}
.practice-set-info h6 {
  margin: 0;
  color: #212529;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.practice-set-info .score-info {
  font-size: 0.875rem;
  color: #6c757d;
  margin-top: 0.25rem;
}

.practice-set-actions {
  display: flex;
  gap: 0.75rem;
  margin-left: 1rem;
  flex-shrink: 0;
  align-items: center;
}
.practice-set-actions .btn {
  min-width: 100px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  line-height: 1;
  margin: 0;
}

.modal {
  display: flex !important;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-dialog {
  margin: 1rem auto;
  max-width: 600px;
  width: 90%;
}

.modal-content {
  border-radius: 12px;
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-header {
  border-bottom: 1px solid #e9ecef;
  padding: 1.25rem 1.5rem;
  border-radius: 12px 12px 0 0;
}

.modal-body {
  padding: 1.5rem 1.25rem !important;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.modal-footer {
  border-top: 1px solid #e9ecef;
  padding: 1.25rem 1.5rem;
  border-radius: 0 0 12px 12px;
}

.topic-completion-chart {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.topic-completion-chart .chart-container {
  height: 300px;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.topic-completion-chart .chart-title {
  text-align: center;
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}
.topic-completion-chart .chart-title .view-details-btn {
  padding: 0;
  color: #564ffd;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
}
.topic-completion-chart .chart-title .view-details-btn:hover {
  color: #4338ca;
  text-decoration: underline;
}

.topic-details-list {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 0.5rem;
}
.topic-details-list::-webkit-scrollbar {
  width: 6px;
}
.topic-details-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.topic-details-list::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.topic-detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 0.75rem;
  transition: background-color 0.2s;
}
.topic-detail-item:hover {
  background-color: #e9ecef;
}
.topic-detail-item .topic-name {
  font-weight: 600;
  color: #2c3e50;
  flex: 1 1;
}
.topic-detail-item .topic-percentages {
  display: flex;
  gap: 1.5rem;
  margin-left: 1rem;
}
.topic-detail-item .topic-percentages .percentage-item {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 80px;
}
.topic-detail-item .topic-percentages .percentage-item .label {
  font-size: 0.8rem;
  color: #6c757d;
  margin-bottom: 0.25rem;
}
.topic-detail-item .topic-percentages .percentage-item .value {
  font-weight: 600;
  color: #2c3e50;
}
.topic-detail-item .topic-percentages .percentage-item.total .value {
  color: #564ffd;
  font-size: 1.1rem;
}

@media (max-width: 1024px) {
  .topic-completion-chart {
    padding: 1rem;
  }
  .topic-completion-chart .chart-container {
    height: 250px;
  }
  .topic-detail-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  .topic-detail-item .topic-percentages {
    margin-left: 0;
    width: 100%;
    justify-content: space-between;
  }
}
.download-section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 16px 24px;
}
.download-section .download-button {
  background: #564ffd;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 600;
  color: white;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}
.download-section .download-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  background: #5a6fd8;
}
.download-section .download-button:disabled {
  opacity: 0.7;
  transform: none;
  box-shadow: 0 2px 10px rgba(102, 126, 234, 0.2);
  cursor: not-allowed;
}
.download-section .download-button .download-content {
  display: flex;
  align-items: center;
  gap: 8px;
}
.download-section .download-button .download-content .download-spinner {
  color: white;
}
.download-section .download-button .download-icon {
  font-size: 1.2rem;
  transition: transform 0.3s ease;
}
.download-section .download-button:hover .download-icon {
  transform: translateY(2px);
}
@media (max-width: 768px) {
  .download-section .responsive-download-btn {
    width: 100%;
    justify-content: center;
  }
}

.diagnostic-container {
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.diagnostic-container .diagnostic-tabs {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 10px;
}
.diagnostic-container .diagnostic-tabs .tab-button {
  padding: 10px 20px;
  border: none;
  background: none;
  font-size: 16px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}
.diagnostic-container .diagnostic-tabs .tab-button:hover {
  color: #2563eb;
}
.diagnostic-container .diagnostic-tabs .tab-button.active {
  color: #2563eb;
  font-weight: 600;
}
.diagnostic-container .diagnostic-tabs .tab-button.active::after {
  content: "";
  position: absolute;
  bottom: -12px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #2563eb;
}
.diagnostic-container .diagnostic-section .section-header {
  margin-bottom: 30px;
  text-align: center;
}
.diagnostic-container .diagnostic-section .section-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
}
.diagnostic-container .diagnostic-section .section-header p {
  font-size: 16px;
  color: #64748b;
}
.diagnostic-container .topics-near-mastery .topics-chart-container {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.diagnostic-container .topics-near-mastery .topic-card-content .topic-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.diagnostic-container .topics-near-mastery .topic-card-content .topic-header h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}
.diagnostic-container .topics-near-mastery .topic-card-content .topic-header .topic-score {
  font-size: 14px;
  font-weight: 500;
  color: #2563eb;
}
.diagnostic-container .topics-near-mastery .topic-card-content .resource-dropdown {
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 14px;
  color: #1e293b;
}
.diagnostic-container .topics-near-mastery .topic-card-content .resource-dropdown:hover {
  background-color: #f1f5f9;
}
.diagnostic-container .recommendations .recommendations-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 30px;
}
.diagnostic-container .recommendations .recommendations-list .recommendation-item {
  background-color: #f8fafc;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #e2e8f0;
}
.diagnostic-container .recommendations .recommendations-list .recommendation-item .recommendation-info {
  margin-bottom: 15px;
}
.diagnostic-container .recommendations .recommendations-list .recommendation-item .recommendation-info .topic-name {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 8px;
}
.diagnostic-container .recommendations .recommendations-list .recommendation-item .recommendation-info .resource-name {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
}
.diagnostic-container .recommendations .recommendations-list .recommendation-item .recommendation-info .priority-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}
.diagnostic-container .recommendations .recommendations-list .recommendation-item .recommendation-info .priority-badge.high {
  background-color: #fee2e2;
  color: #dc2626;
}
.diagnostic-container .recommendations .recommendations-list .recommendation-item .recommendation-info .priority-badge.medium {
  background-color: #fef3c7;
  color: #d97706;
}
.diagnostic-container .recommendations .recommendations-list .recommendation-item .recommendation-info .priority-badge.low {
  background-color: #dcfce7;
  color: #16a34a;
}
.diagnostic-container .recommendations .recommendations-list .recommendation-item .recommendation-progress {
  margin-bottom: 15px;
}
.diagnostic-container .recommendations .recommendations-list .recommendation-item .recommendation-progress .progress-bar {
  height: 6px;
  background-color: #e2e8f0;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 4px;
}
.diagnostic-container .recommendations .recommendations-list .recommendation-item .recommendation-progress .progress-bar .progress-fill {
  height: 100%;
  background-color: #2563eb;
  transition: width 0.3s ease;
}
.diagnostic-container .recommendations .recommendations-list .recommendation-item .recommendation-progress .progress-text {
  font-size: 12px;
  color: #64748b;
}
.diagnostic-container .growth-progress .growth-progress-content {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}
.diagnostic-container .growth-progress .growth-progress-content .pyramid-chart {
  flex: 1 1;
  max-width: 400px;
}
.diagnostic-container .growth-progress .growth-progress-content .topics-details {
  flex: 2 1;
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.diagnostic-container .growth-progress .growth-progress-content .topics-details .topics-section {
  background-color: #f8fafc;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #e2e8f0;
}
.diagnostic-container .growth-progress .growth-progress-content .topics-details .topics-section h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 15px;
}
.diagnostic-container .growth-progress .growth-progress-content .topics-details .topics-section .topics-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
}
.diagnostic-container .growth-progress .growth-progress-content .topics-details .topics-section .topics-list .topic-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: white;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}
.diagnostic-container .growth-progress .growth-progress-content .topics-details .topics-section .topics-list .topic-item .topic-name {
  font-size: 14px;
  color: #1e293b;
}
.diagnostic-container .growth-progress .growth-progress-content .topics-details .topics-section .topics-list .topic-item .status-badge {
  font-size: 12px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 4px;
}
.diagnostic-container .growth-progress .growth-progress-content .topics-details .topics-section .topics-list .topic-item .status-badge.basic {
  background-color: #fee2e2;
  color: #dc2626;
}
.diagnostic-container .growth-progress .growth-progress-content .topics-details .topics-section .topics-list .topic-item .status-badge.inProgress {
  background-color: #fef3c7;
  color: #d97706;
}
.diagnostic-container .growth-progress .growth-progress-content .topics-details .topics-section .topics-list .topic-item .status-badge.mastered {
  background-color: #dcfce7;
  color: #16a34a;
}

.dropdown-menu {
  padding: 6px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1050;
  position: absolute;
  width: 100%;
  margin-top: 4px;
  background: white;
  transform: none !important;
  min-width: 200px;
  max-width: 300px;
}
.dropdown-menu .dropdown-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  color: #4a5568;
  font-size: 13px;
  white-space: normal;
  word-wrap: break-word;
  position: relative;
  line-height: 1.4;
  min-height: 40px;
}
.dropdown-menu .dropdown-item:hover {
  background: #f7fafc;
  color: #564ffd;
}
.dropdown-menu .dropdown-item .resource-icon {
  color: #564ffd;
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  margin-top: 2px;
}
.dropdown-menu .dropdown-item .resource-name {
  flex: 1 1;
  min-width: 0;
}

.resource-dropdown {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  font-size: 14px;
  background-color: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  color: #4a5568;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.resource-dropdown:hover {
  background-color: #edf2f7;
}
.resource-dropdown .dropdown-toggle-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}
.resource-dropdown .dropdown-toggle-content .dropdown-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown {
  position: relative;
}
.dropdown.show {
  z-index: 1050;
}
.dropdown .dropdown-toggle::after {
  display: none;
}

foreignObject {
  overflow: visible !important;
  pointer-events: all;
}

@media (max-width: 1024px) {
  .diagnostic-container {
    padding: 16px;
  }
  .diagnostic-container .topics-near-mastery .topics-chart-container {
    margin-top: 24px;
  }
  .diagnostic-container .topics-near-mastery .topics-chart {
    height: 400px;
  }
  .diagnostic-container .recommendations .recommendation-item {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
  .diagnostic-container .recommendations .recommendation-item .recommendation-info {
    text-align: center;
  }
  .diagnostic-container .recommendations .recommendation-item .recommendation-progress {
    margin: 16px 0;
  }
}
.growth-progress-container {
  padding: 20px;
}
.growth-progress-container .growth-progress-header {
  margin-bottom: 32px;
}
.growth-progress-container .growth-progress-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
}
.growth-progress-container .growth-progress-header p {
  color: #718096;
  font-size: 16px;
}
.growth-progress-container .growth-progress-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}
.growth-progress-container .pyramid-chart {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.growth-progress-container .pyramid-chart svg {
  width: 100%;
  height: auto;
}
.growth-progress-container .topics-details {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 32px;
}
.growth-progress-container .topics-details .topics-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.growth-progress-container .topics-details .topics-section h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
}
.growth-progress-container .topics-details .topics-section h3.mastered {
  color: #4caf50;
}
.growth-progress-container .topics-details .topics-section h3.in-progress {
  color: #ffa726;
}
.growth-progress-container .topics-details .topics-section h3.basic {
  color: #ef5350;
}
.growth-progress-container .topics-details .topics-section .topics-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 300px;
  overflow-y: auto;
}
.growth-progress-container .topics-details .topics-section .topics-list::-webkit-scrollbar {
  width: 6px;
}
.growth-progress-container .topics-details .topics-section .topics-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.growth-progress-container .topics-details .topics-section .topics-list::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 3px;
}
.growth-progress-container .topics-details .topics-section .topic-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f7fafc;
  border-radius: 6px;
  transition: transform 0.2s ease;
}
.growth-progress-container .topics-details .topics-section .topic-item:hover {
  transform: translateX(4px);
}
.growth-progress-container .topics-details .topics-section .topic-item .topic-name {
  font-size: 14px;
  color: #4a5568;
  flex: 1 1;
  margin-right: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.growth-progress-container .topics-details .topics-section .topic-item .status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.growth-progress-container .topics-details .topics-section .topic-item .status-badge.mastered {
  background: #4caf50;
  color: white;
}
.growth-progress-container .topics-details .topics-section .topic-item .status-badge.in-progress {
  background: #ffa726;
  color: white;
}
.growth-progress-container .topics-details .topics-section .topic-item .status-badge.basic {
  background: #ef5350;
  color: white;
}

@media (max-width: 1024px) {
  .growth-progress-container .topics-details {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 1024px) {
  .growth-progress-container {
    padding: 16px;
  }
  .growth-progress-container .topics-details {
    grid-template-columns: 1fr;
  }
  .growth-progress-container .pyramid-chart {
    padding: 16px;
  }
}
.filter-dropdown {
  position: relative;
  display: inline-block;
}
.filter-dropdown .filter-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  color: #333;
  font-size: 14px;
  transition: all 0.2s ease;
  width: 100%;
}
.filter-dropdown .filter-button:hover {
  background: #f8f9fa;
  border-color: #dee2e6;
}
.filter-dropdown .filter-button .filter-icon {
  font-size: 16px;
  color: #666;
}
.filter-dropdown .filter-button .filter-text {
  font-weight: 500;
}
.filter-dropdown .filter-button .filter-badge {
  background: #e3f2fd;
  color: #1976d2;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}
.filter-dropdown .filter-menu {
  position: absolute;
  left: 0;
  top: 100%;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 250px;
  background: white;
  z-index: 1000;
  margin-top: 8px;
}
.filter-dropdown .filter-menu .filter-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.filter-dropdown .filter-menu .filter-menu-header .filter-menu-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #333;
  font-weight: 600;
}
.filter-dropdown .filter-menu .filter-menu-header .filter-menu-title .filter-menu-icon {
  font-size: 16px;
  color: #666;
}
.filter-dropdown .filter-menu .filter-menu-header .filter-menu-title h5 {
  margin: 0;
  font-size: 14px;
}
.filter-dropdown .filter-menu .filter-menu-header .clear-all {
  color: #1976d2;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
}
.filter-dropdown .filter-menu .filter-menu-header .clear-all:hover {
  background: #e3f2fd;
}
.filter-dropdown .filter-menu .filter-menu-divider {
  height: 1px;
  background: #e0e0e0;
  margin: 8px 0;
}
.filter-dropdown .filter-menu .filter-options {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 4px;
}
.filter-dropdown .filter-menu .filter-options::-webkit-scrollbar {
  width: 6px;
}
.filter-dropdown .filter-menu .filter-options::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.filter-dropdown .filter-menu .filter-options::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}
.filter-dropdown .filter-menu .filter-options::-webkit-scrollbar-thumb:hover {
  background: #999;
}
.filter-dropdown .filter-menu .filter-options .filter-option {
  padding: 8px 0;
}
.filter-dropdown .filter-menu .filter-options .filter-option .custom-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.filter-dropdown .filter-menu .filter-options .filter-option .custom-checkbox input[type=checkbox] {
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
}
.filter-dropdown .filter-menu .filter-options .filter-option .custom-checkbox label {
  margin: 0;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}
.filter-dropdown .filter-menu .filter-options .filter-option .custom-checkbox:hover label {
  color: #1976d2;
}

.topic-card-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 8px;
}
.topic-card-content .topic-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
}
.topic-card-content .topic-header .topic-name {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  cursor: default;
}
.topic-card-content .topic-header .topic-score {
  font-size: 16px;
  font-weight: 600;
  color: #4a5568;
  white-space: nowrap;
}
.topic-card-content .resource-dropdown {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  font-size: 14px;
  background-color: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  color: #4a5568;
}
.topic-card-content .resource-dropdown:hover {
  background-color: #edf2f7;
}

.resource-dropdown-menu {
  padding: 0;
}
.resource-dropdown-menu .scrollable-menu {
  max-height: 200px;
  overflow-y: auto;
}
.resource-dropdown-menu .scrollable-menu::-webkit-scrollbar {
  width: 6px;
}
.resource-dropdown-menu .scrollable-menu::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.resource-dropdown-menu .scrollable-menu::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}
.resource-dropdown-menu .scrollable-menu::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.resource-dropdown-menu .dropdown-item {
  padding: 8px 16px;
}
.resource-dropdown-menu .dropdown-item:hover {
  background-color: #f8f9fa;
}
.resource-dropdown-menu .dropdown-item .resource-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* PDF Report Styles */
.pdf-report {
  position: fixed;
  top: -9999px;
  left: -9999px;
  width: 210mm;
  background-color: white;
  padding: 20px;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
}
.pdf-report.generating {
  position: relative;
  top: auto;
  left: auto;
  z-index: 1;
  opacity: 1;
  pointer-events: auto;
}
.pdf-report .pdf-section {
  margin-bottom: 30px;
}
.pdf-report .pdf-section .pdf-section-title {
  color: #1f2937;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e5e7eb;
}
.pdf-report .pdf-scores-container {
  max-height: none !important;
  overflow: visible !important;
}
.pdf-report .pdf-scores-container .scores-list {
  max-height: none !important;
  overflow: visible !important;
  height: auto !important;
  display: block !important;
}
.pdf-report .pdf-scores-container .excel-grid {
  max-height: none !important;
  overflow: visible !important;
  height: auto !important;
  display: block !important;
}
.pdf-report .pdf-scores-container .grid-row {
  display: grid;
  grid-template-columns: 2fr 1fr;
  border-bottom: 1px solid #dee2e6;
  transition: background-color 0.2s;
}
.pdf-report .pdf-scores-container .grid-row:hover {
  background-color: #f8f9fa;
}
.pdf-report .pdf-scores-container .grid-row:last-child {
  border-bottom: none;
}
.pdf-report .pdf-scores-container .grid-cell {
  padding: 12px 16px;
  font-size: 14px;
  color: #495057;
  border-right: 1px solid #dee2e6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pdf-report .pdf-scores-container .grid-cell:last-child {
  border-right: none;
  text-align: right;
  font-weight: 500;
}
.pdf-report .page-break {
  page-break-after: always;
  height: 0;
  margin: 0;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/Performance/styles.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,gCAAA;EACA,yBAAA;EACA,wBAAA;EACA,oBAAA;EACA,8BAAA;EACA,eAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;AACJ;;AAGA;;EAEE,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;EACA,sBAAA;AAAF;;AAGA;EACE,8BAAA;EACA,8BAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,2BAAA;AAAF;;AASA;EACE;IACE,mBAAA;IACA,8BAAA;IACA,mBAAA;EANF;EASA;IACE,aAAA;EAPF;EAUA;;IAEE,eAAA;IACA,iBAAA;EARF;AACF;AAWA,+CAAA;AACA;EACE;IACE,YAAA;IACA,eAAA;EATF;EAYA;IACE,eAAA;IACA,iBAAA;EAVF;EAaA;IACE,eAAA;IACA,iBAAA;EAXF;EAcA;IACE,iBAAA;IACA,eAAA;EAZF;EAeA;IACE,eAAA;EAbF;AACF;AAgBA,+CAAA;AACA;EACE;IACE,YAAA;IACA,eAAA;EAdF;EAiBA;IACE,cAAA;IACA,iBAAA;EAfF;EAkBA;IACE,cAAA;IACA,iBAAA;EAhBF;EAmBA;IACE,gBAAA;IACA,eAAA;EAjBF;EAoBA;IACE,eAAA;EAlBF;AACF;AAqBA;EACE,yBAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AAnBF;AAqBE;EACE,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AAnBJ;AAqBI;EACE,4BAAA;EACA,+BAAA;AAnBN;AAsBI;EACE,6BAAA;EACA,gCAAA;AApBN;AAuBI;EACE,kBAAA;AArBN;AAwBI;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AAtBN;AAyBI;EACE,mBAAA;AAvBN;;AA4BA;EACE,aAAA;EACA,4DAAA;EACA,WAAA;EACA,aAAA;AAzBF;AA2BE;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;AAzBJ;AA2BI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AAzBN;AA4BI;EACE,cAAA;EACA,eAAA;EACA,SAAA;AA1BN;;AA+BA;EACE,yBAAA;EACA,mBAAA;EACA,mEAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AA5BF;AA8BE;EACE,2BAAA;EACA,yCAAA;AA5BJ;AA+BE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AA7BJ;AAgCE;EACE,SAAA;EACA,YAAA;AA9BJ;AAgCI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA9BN;AAkCE;EACE,aAAA;EACA,SAAA;EACA,cAAA;AAhCJ;AAkCI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAhCN;AAkCM;EACE,iBAAA;AAhCR;AAmCM;EACE,gBAAA;EACA,cAAA;AAjCR;AAsCE;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;AApCJ;AAsCI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AApCN;AAsCM;EACE,eAAA;EACA,cAAA;AApCR;AAuCM;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AArCR;AA0CE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAxCJ;AA2CE;EACE,2BAAA;AAzCJ;AA4CE;EACE,gBAAA;AA1CJ;;AA8CA;EACE;IACE,gBAAA;IACA,iBAAA;IACA,iCAAA;EA3CF;EA6CE;IACE,aAAA;EA3CJ;EA8CE;IACE,iBAAA;IACA,iBAAA;IACA,mBAAA;EA5CJ;AACF;AAgDA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AA9CF;;AAiDA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iCAAA;AA9CF;AAgDE;EACE,yBAAA;AA9CJ;;AAkDA;EACE,gBAAA;EACA,cAAA;AA/CF;;AAkDA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AA/CF;;AAkDA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AA/CF;;AAkDA;EACE,aAAA;EACA,8BAAA;EACA,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AA/CF;;AAkDA;EACE,aAAA;EACA,8BAAA;EACA,gCAAA;EACA,iCAAA;AA/CF;AAiDE;EACE,yBAAA;AA/CJ;AAkDE;EACE,mBAAA;AAhDJ;;AAoDA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjDF;AAmDE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;AAjDJ;;AAqDA;EACE,gBAAA;EACA,cAAA;EACA,yBAAA;AAlDF;;AAqDA;EACE,eAAA;EACA,cAAA;AAlDF;AAoDE;EACE,yBAAA;AAlDJ;;AAsDA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAnDF;AAqDE;EACE,UAAA;AAnDJ;AAsDE;EACE,mBAAA;EACA,kBAAA;AApDJ;AAuDE;EACE,gBAAA;EACA,kBAAA;AArDJ;;AAyDA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,iCAAA;EACA,gBAAA;AAtDF;AAwDE;EACE,yBAAA;AAtDJ;;AA0DA;EACE,SAAA;EACA,YAAA;AAvDF;AAyDE;EACE,SAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAvDJ;AA0DE;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;AAxDJ;;AA4DA;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAzDF;AA2DE;EACE,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;AAzDJ;;AA8DA;EACE,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;AA3DF;;AA8DA;EACE,iBAAA;EACA,gBAAA;EACA,UAAA;AA3DF;;AA8DA;EACE,mBAAA;EACA,YAAA;EACA,0CAAA;AA3DF;;AA8DA;EACE,gCAAA;EACA,uBAAA;EACA,4BAAA;AA3DF;;AA8DA;EACE,kCAAA;EACA,+BAAA;EACA,gBAAA;AA3DF;;AA8DA;EACE,6BAAA;EACA,uBAAA;EACA,4BAAA;AA3DF;;AA8DA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,yCAAA;AA3DF;AA6DE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3DJ;AA8DE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AA5DJ;AA8DI;EACE,UAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AA5DN;AA8DM;EACE,cAAA;EACA,0BAAA;AA5DR;;AAkEA;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;AA/DF;AAiEE;EACE,UAAA;AA/DJ;AAkEE;EACE,mBAAA;EACA,kBAAA;AAhEJ;AAmEE;EACE,gBAAA;EACA,kBAAA;AAjEJ;;AAqEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;AAlEF;AAoEE;EACE,yBAAA;AAlEJ;AAqEE;EACE,gBAAA;EACA,cAAA;EACA,SAAA;AAnEJ;AAsEE;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AApEJ;AAsEI;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;AApEN;AAsEM;EACE,iBAAA;EACA,cAAA;EACA,sBAAA;AApER;AAuEM;EACE,gBAAA;EACA,cAAA;AArER;AAyEQ;EACE,cAAA;EACA,iBAAA;AAvEV;;AA8EA;EACE;IACE,aAAA;EA3EF;EA6EE;IACE,aAAA;EA3EJ;EA+EA;IACE,sBAAA;IACA,uBAAA;IACA,YAAA;EA7EF;EA+EE;IACE,cAAA;IACA,WAAA;IACA,8BAAA;EA7EJ;AACF;AAiFA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;AA/EF;AAiFE;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,+CAAA;AA/EJ;AAiFI;EACE,2BAAA;EACA,+CAAA;EACA,mBAAA;AA/EN;AAkFI;EACE,YAAA;EACA,eAAA;EACA,+CAAA;EACA,mBAAA;AAhFN;AAmFI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAjFN;AAmFM;EACE,YAAA;AAjFR;AAqFI;EACE,iBAAA;EACA,+BAAA;AAnFN;AAsFI;EACE,0BAAA;AApFN;AAyFI;EADF;IAEI,WAAA;IACA,uBAAA;EAtFJ;AACF;;AA2FA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,wCAAA;AAxFF;AA0FE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gCAAA;EACA,oBAAA;AAxFJ;AA0FI;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AAxFN;AA0FM;EACE,cAAA;AAxFR;AA2FM;EACE,cAAA;EACA,gBAAA;AAzFR;AA2FQ;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AAzFV;AAgGI;EACE,mBAAA;EACA,kBAAA;AA9FN;AAgGM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA9FR;AAiGM;EACE,eAAA;EACA,cAAA;AA/FR;AAsGI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AApGN;AAwGM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAtGR;AAwGQ;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AAtGV;AAyGQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAvGV;AA2GM;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAzGR;AA2GQ;EACE,yBAAA;AAzGV;AAiHI;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AA/GN;AAiHM;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;AA/GR;AAiHQ;EACE,mBAAA;AA/GV;AAiHU;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AA/GZ;AAkHU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAhHZ;AAmHU;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAjHZ;AAmHY;EACE,yBAAA;EACA,cAAA;AAjHd;AAoHY;EACE,yBAAA;EACA,cAAA;AAlHd;AAqHY;EACE,yBAAA;EACA,cAAA;AAnHd;AAwHQ;EACE,mBAAA;AAtHV;AAwHU;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAtHZ;AAwHY;EACE,YAAA;EACA,yBAAA;EACA,2BAAA;AAtHd;AA0HU;EACE,eAAA;EACA,cAAA;AAxHZ;AAiII;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AA/HN;AAiIM;EACE,SAAA;EACA,gBAAA;AA/HR;AAkIM;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAhIR;AAkIQ;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;AAhIV;AAkIU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAhIZ;AAmIU;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAjIZ;AAmIY;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AAjId;AAmIc;EACE,eAAA;EACA,cAAA;AAjIhB;AAoIc;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAlIhB;AAoIgB;EACE,yBAAA;EACA,cAAA;AAlIlB;AAqIgB;EACE,yBAAA;EACA,cAAA;AAnIlB;AAsIgB;EACE,yBAAA;EACA,cAAA;AApIlB;;AAgJA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;AA7IF;AA+IE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA7IJ;AA+II;EACE,mBAAA;EACA,cAAA;AA7IN;AAgJI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AA9IN;AAiJI;EACE,SAAA;EACA,YAAA;AA/IN;;AA2KA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAxKF;AA0KE;EACE,yBAAA;AAxKJ;AA2KE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;AAzKJ;AA2KI;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAzKN;;AA+KA;EACE,kBAAA;AA5KF;AA8KE;EACE,aAAA;AA5KJ;AAgLI;EACE,aAAA;AA9KN;;AAoLA;EACE,4BAAA;EACA,mBAAA;AAjLF;;AAqLA;EACE;IACE,aAAA;EAlLF;EAqLI;IACE,gBAAA;EAnLN;EAsLI;IACE,aAAA;EApLN;EAyLI;IACE,sBAAA;IACA,SAAA;IACA,kBAAA;EAvLN;EAyLM;IACE,kBAAA;EAvLR;EA0LM;IACE,cAAA;EAxLR;AACF;AA+LA;EACE,aAAA;AA7LF;AA+LE;EACE,mBAAA;AA7LJ;AA+LI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA7LN;AAgMI;EACE,cAAA;EACA,eAAA;AA9LN;AAkME;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAhMJ;AAmME;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;AAjMJ;AAmMI;EACE,WAAA;EACA,YAAA;AAjMN;AAqME;EACE,WAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;EACA,gBAAA;AAnMJ;AAqMI;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;AAnMN;AAqMM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AAnMR;AAqMQ;EACE,cAAA;AAnMV;AAsMQ;EACE,cAAA;AApMV;AAuMQ;EACE,cAAA;AArMV;AAyMM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AAvMR;AAyMQ;EACE,UAAA;AAvMV;AA0MQ;EACE,mBAAA;EACA,kBAAA;AAxMV;AA2MQ;EACE,mBAAA;EACA,kBAAA;AAzMV;AA6MM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;AA3MR;AA6MQ;EACE,0BAAA;AA3MV;AA8MQ;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA5MV;AA+MQ;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA7MV;AA+MU;EACE,mBAAA;EACA,YAAA;AA7MZ;AAgNU;EACE,mBAAA;EACA,YAAA;AA9MZ;AAiNU;EACE,mBAAA;EACA,YAAA;AA/MZ;;AAwNA;EAEI;IACE,qCAAA;EAtNJ;AACF;AA0NA;EACE;IACE,aAAA;EAxNF;EA0NE;IACE,0BAAA;EAxNJ;EA2NE;IACE,aAAA;EAzNJ;AACF;AA8NA;EACE,kBAAA;EACA,qBAAA;AA5NF;AA8NE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;AA5NJ;AA8NI;EACE,mBAAA;EACA,qBAAA;AA5NN;AA+NI;EACE,eAAA;EACA,WAAA;AA7NN;AAgOI;EACE,gBAAA;AA9NN;AAiOI;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA/NN;AAmOE;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AAjOJ;AAmOI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAjON;AAmOM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;AAjOR;AAmOQ;EACE,eAAA;EACA,WAAA;AAjOV;AAoOQ;EACE,SAAA;EACA,eAAA;AAlOV;AAsOM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AApOR;AAsOQ;EACE,mBAAA;AApOV;AAyOI;EACE,WAAA;EACA,mBAAA;EACA,aAAA;AAvON;AA0OI;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAxON;AA0OM;EACE,UAAA;AAxOR;AA2OM;EACE,mBAAA;EACA,kBAAA;AAzOR;AA4OM;EACE,gBAAA;EACA,kBAAA;AA1OR;AA4OQ;EACE,gBAAA;AA1OV;AA8OM;EACE,cAAA;AA5OR;AA8OQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AA5OV;AA8OU;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;AA5OZ;AA+OU;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AA7OZ;AAiPY;EACE,cAAA;AA/Od;;AAwPA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,QAAA;AArPF;AAuPE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,QAAA;AArPJ;AAuPI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AArPN;AAwPI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAtPN;AA0PE;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAxPJ;AA0PI;EACE,yBAAA;AAxPN;;AA6PA;EACE,UAAA;AA1PF;AA4PE;EACE,iBAAA;EACA,gBAAA;AA1PJ;AA6PI;EACE,UAAA;AA3PN;AA8PI;EACE,mBAAA;EACA,kBAAA;AA5PN;AA+PI;EACE,gBAAA;EACA,kBAAA;AA7PN;AA+PM;EACE,gBAAA;AA7PR;AAkQE;EACE,iBAAA;AAhQJ;AAkQI;EACE,yBAAA;AAhQN;AAmQI;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjQN;;AAsQA,sBAAA;AACA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;AAnQF;AAsQE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;AApQJ;AAuQE;EACE,mBAAA;AArQJ;AAuQI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AArQN;AAyQE;EACE,2BAAA;EACA,4BAAA;AAvQJ;AAyQI;EACE,2BAAA;EACA,4BAAA;EACA,uBAAA;EACA,yBAAA;AAvQN;AA0QI;EACE,2BAAA;EACA,4BAAA;EACA,uBAAA;EACA,yBAAA;AAxQN;AA2QI;EACE,aAAA;EACA,8BAAA;EACA,gCAAA;EACA,iCAAA;AAzQN;AA2QM;EACE,yBAAA;AAzQR;AA4QM;EACE,mBAAA;AA1QR;AA8QI;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA5QN;AA8QM;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;AA5QR;AAiRE;EACE,wBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AA/QJ","sourcesContent":[".list-group-item {\n  border: 1px solid #e9eaf0;\n  border-radius: 8px;\n  margin-bottom: 10px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column; // Adjusted for mobile view\n}\n\n.user-management-back-button {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 48px;\n  letter-spacing: -0.008em;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  color: #564ffd;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.class-details {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  color: #1d2026;\n  margin-bottom: 4px; // Added margin for better spacing\n}\n\n.class-details-light {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  color: #8c94a3;\n}\n\n.play-button {\n  text-decoration: none !important;\n  color: #ff6636 !important;\n  display: flex !important;\n  gap: 10px !important;\n  align-items: center !important;\n  margin-top: 8px; // Added margin for better spacing\n}\n\n.nav-tabs {\n  gap: 10px;\n  padding: 0 10px;\n  border-bottom: 0 !important;\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  white-space: nowrap;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n  color: #ff6636 !important;\n  border: 0.5px solid;\n  border-radius: 44px;\n  border-color: #ff6636 !important;\n  background-color: #fff; // Ensure the active tab stands out\n}\n\n.nav-tabs .nav-link {\n  border: 0.5px solid !important;\n  border-radius: 44px !important;\n  color: #8c94a3 !important;\n  background-color: #f8f9fa; // Lighter background for inactive tabs\n  padding: 8px 16px; // Adjusted padding for better touch targets on mobile\n  margin-bottom: 0 !important;\n}\n\n// .list-group-item > div {\n//   display: flex;\n//   flex-direction: column;\n//   align-items: flex-start;\n// }\n\n@media (min-width: 1024px) {\n  .list-group-item {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .play-button {\n    margin-top: 0;\n  }\n\n  .class-details,\n  .class-details-light {\n    font-size: 14px;\n    line-height: 22px;\n  }\n}\n\n/* Media query for screens smaller than 408px */\n@media (max-width: 408px) {\n  .trouble-spot-name {\n    padding: 8px; // Reduce padding\n    font-size: 12px;\n  }\n\n  .class-details {\n    font-size: 10px; // Smaller font size\n    line-height: 18px;\n  }\n\n  .class-details-light {\n    font-size: 10px; // Smaller font size for lighter details\n    line-height: 16px;\n  }\n\n  .nav-tabs .nav-link {\n    padding: 6px 12px; // Adjust padding for smaller screens\n    font-size: 12px;\n  }\n\n  .play-button {\n    font-size: 12px; // Adjust button font size\n  }\n}\n\n/* Media query for screens smaller than 370px */\n@media (max-width: 370px) {\n  .trouble-spot-name {\n    padding: 6px; // Further reduce padding\n    font-size: 10px;\n  }\n\n  .class-details {\n    font-size: 8px; // Even smaller font size\n    line-height: 16px;\n  }\n\n  .class-details-light {\n    font-size: 7px; // Further reduce font size\n    line-height: 14px;\n  }\n\n  .nav-tabs .nav-link {\n    padding: 4px 8px; // Further reduce padding\n    font-size: 10px;\n  }\n\n  .play-button {\n    font-size: 10px; // Further adjust button font size\n  }\n}\n\n.page-break {\n  page-break-before: always;\n  break-before: page;\n}\n\n.filter-buttons {\n  display: flex;\n  justify-content: center;\n  padding: 0 1rem;\n\n  .filter-btn {\n    padding: 8px 16px;\n    border: 1px solid #e0e0e0;\n    background: white;\n    color: #6c757d;\n    font-weight: 500;\n    transition: all 0.2s ease;\n    cursor: pointer;\n\n    &:first-child {\n      border-top-left-radius: 20px;\n      border-bottom-left-radius: 20px;\n    }\n\n    &:last-child {\n      border-top-right-radius: 20px;\n      border-bottom-right-radius: 20px;\n    }\n\n    &:not(:last-child) {\n      border-right: none;\n    }\n\n    &.active {\n      background: #564ffd;\n      color: white;\n      border-color: #564ffd;\n    }\n\n    &:hover:not(.active) {\n      background: #f8f9fa;\n    }\n  }\n}\n\n.exam-attempts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n  padding: 1rem;\n\n  .no-results-message {\n    grid-column: 1 / -1;\n    text-align: center;\n    padding: 3rem 1rem;\n    background: #f8f9fa;\n    border-radius: 12px;\n    border: 1px dashed #dee2e6;\n\n    h4 {\n      color: #2c3e50;\n      font-size: 1.25rem;\n      font-weight: 600;\n      margin-bottom: 0.5rem;\n    }\n\n    p {\n      color: #6c757d;\n      font-size: 1rem;\n      margin: 0;\n    }\n  }\n}\n\n.exam-attempt-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n  background: white;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n\n  .card-body {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    padding: 1.25rem;\n  }\n\n  .exam-title-container {\n    flex: 1;\n    min-width: 0; // Enable text truncation\n\n    .card-title {\n      font-size: 1.1rem;\n      font-weight: 600;\n      color: #2c3e50;\n      margin-bottom: 0.5rem;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .exam-stats {\n    display: flex;\n    gap: 1rem;\n    flex-shrink: 0;\n\n    .stat-item {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n\n      svg {\n        font-size: 1.2rem;\n      }\n\n      span {\n        font-weight: 500;\n        color: #2c3e50;\n      }\n    }\n  }\n\n  .exam-details {\n    display: flex;\n    gap: 1.5rem;\n    margin-top: 1rem;\n    color: #6c757d;\n    font-size: 0.9rem;\n    flex-shrink: 0;\n\n    .detail-item {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      min-width: 0; // Enable text truncation\n\n      svg {\n        font-size: 1rem;\n        flex-shrink: 0;\n      }\n\n      span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n\n  .progress {\n    background-color: #f8f9fa;\n    border-radius: 3px;\n    overflow: hidden;\n    flex-shrink: 0;\n  }\n\n  .progress-bar {\n    transition: width 0.6s ease;\n  }\n\n  .mt-3.w-100 {\n    margin-top: auto;\n  }\n}\n\n@media (max-width: 1024px) {\n  .filter-buttons {\n    overflow-x: auto;\n    padding: 0 0.5rem;\n    -webkit-overflow-scrolling: touch;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    .filter-btn {\n      padding: 6px 12px;\n      font-size: 0.9rem;\n      white-space: nowrap;\n    }\n  }\n}\n\n.topic-scores-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.topic-score-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n\n  &:hover {\n    background-color: #e9ecef;\n  }\n}\n\n.topic-name {\n  font-weight: 500;\n  color: #495057;\n}\n\n.topic-score {\n  font-weight: 600;\n  color: #0d6efd;\n  min-width: 60px;\n  text-align: right;\n}\n\n.excel-grid {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  overflow: hidden;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.grid-header {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  background-color: #f8f9fa;\n  border-bottom: 2px solid #dee2e6;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.grid-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  border-bottom: 1px solid #dee2e6;\n  transition: background-color 0.2s;\n\n  &:hover {\n    background-color: #f8f9fa;\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.grid-cell {\n  padding: 12px 16px;\n  font-size: 14px;\n  color: #495057;\n  border-right: 1px solid #dee2e6;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  &:last-child {\n    border-right: none;\n    text-align: right;\n    font-weight: 500;\n  }\n}\n\n.grid-header .grid-cell {\n  font-weight: 600;\n  color: #212529;\n  background-color: #f8f9fa;\n}\n\n.grid-cell.clickable {\n  cursor: pointer;\n  color: #0d6efd;\n\n  &:hover {\n    background-color: #f8f9fa;\n  }\n}\n\n.practice-sets-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  max-height: 60vh;\n  overflow-y: auto;\n  padding-right: 0.5rem; // Add padding for scrollbar\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n.practice-set-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  transition: background-color 0.2s;\n  min-height: 80px; // Ensure consistent height\n\n  &:hover {\n    background-color: #e9ecef;\n  }\n}\n\n.practice-set-info {\n  flex: 1;\n  min-width: 0; // Enable text truncation\n\n  h6 {\n    margin: 0;\n    color: #212529;\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .score-info {\n    font-size: 0.875rem;\n    color: #6c757d;\n    margin-top: 0.25rem;\n  }\n}\n\n.practice-set-actions {\n  display: flex;\n  gap: 0.75rem;\n  margin-left: 1rem;\n  flex-shrink: 0; // Prevent buttons from shrinking\n  align-items: center; // Ensure vertical alignment\n\n  .btn {\n    min-width: 100px; // Ensure consistent button width\n    height: 32px; // Ensure consistent button height\n    display: inline-flex; // Change to inline-flex\n    align-items: center;\n    justify-content: center;\n    padding: 0; // Remove default padding\n    line-height: 1; // Reset line height\n    margin: 0; // Remove any margin\n  }\n}\n\n// Modal specific styles\n.modal {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.modal-dialog {\n  margin: 1rem auto;\n  max-width: 600px;\n  width: 90%;\n}\n\n.modal-content {\n  border-radius: 12px;\n  border: none;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.modal-header {\n  border-bottom: 1px solid #e9ecef;\n  padding: 1.25rem 1.5rem;\n  border-radius: 12px 12px 0 0;\n}\n\n.modal-body {\n  padding: 1.5rem 1.25rem !important;\n  max-height: calc(100vh - 200px);\n  overflow-y: auto;\n}\n\n.modal-footer {\n  border-top: 1px solid #e9ecef;\n  padding: 1.25rem 1.5rem;\n  border-radius: 0 0 12px 12px;\n}\n\n.topic-completion-chart {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n  .chart-container {\n    height: 300px;\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .chart-title {\n    text-align: center;\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #2c3e50;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n\n    .view-details-btn {\n      padding: 0;\n      color: #564ffd;\n      text-decoration: none;\n      font-size: 0.9rem;\n      font-weight: 500;\n\n      &:hover {\n        color: #4338ca;\n        text-decoration: underline;\n      }\n    }\n  }\n}\n\n.topic-details-list {\n  max-height: 60vh;\n  overflow-y: auto;\n  padding-right: 0.5rem;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n.topic-detail-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  margin-bottom: 0.75rem;\n  transition: background-color 0.2s;\n\n  &:hover {\n    background-color: #e9ecef;\n  }\n\n  .topic-name {\n    font-weight: 600;\n    color: #2c3e50;\n    flex: 1;\n  }\n\n  .topic-percentages {\n    display: flex;\n    gap: 1.5rem;\n    margin-left: 1rem;\n\n    .percentage-item {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      min-width: 80px;\n\n      .label {\n        font-size: 0.8rem;\n        color: #6c757d;\n        margin-bottom: 0.25rem;\n      }\n\n      .value {\n        font-weight: 600;\n        color: #2c3e50;\n      }\n\n      &.total {\n        .value {\n          color: #564ffd;\n          font-size: 1.1rem;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1024px) {\n  .topic-completion-chart {\n    padding: 1rem;\n\n    .chart-container {\n      height: 250px;\n    }\n  }\n\n  .topic-detail-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n\n    .topic-percentages {\n      margin-left: 0;\n      width: 100%;\n      justify-content: space-between;\n    }\n  }\n}\n\n.download-section {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin: 16px 24px;\n\n  .download-button {\n    background: #564ffd;\n    border: none;\n    border-radius: 8px;\n    padding: 12px 24px;\n    font-weight: 600;\n    color: white;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n      background: #5a6fd8;\n    }\n\n    &:disabled {\n      opacity: 0.7;\n      transform: none;\n      box-shadow: 0 2px 10px rgba(102, 126, 234, 0.2);\n      cursor: not-allowed;\n    }\n\n    .download-content {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n\n      .download-spinner {\n        color: white;\n      }\n    }\n\n    .download-icon {\n      font-size: 1.2rem;\n      transition: transform 0.3s ease;\n    }\n\n    &:hover .download-icon {\n      transform: translateY(2px);\n    }\n  }\n\n  .responsive-download-btn {\n    @media (max-width: 768px) {\n      width: 100%;\n      justify-content: center;\n    }\n  }\n}\n\n// Diagnostic Styles\n.diagnostic-container {\n  padding: 20px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n  .diagnostic-tabs {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 30px;\n    border-bottom: 2px solid #e2e8f0;\n    padding-bottom: 10px;\n\n    .tab-button {\n      padding: 10px 20px;\n      border: none;\n      background: none;\n      font-size: 16px;\n      font-weight: 500;\n      color: #64748b;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      position: relative;\n\n      &:hover {\n        color: #2563eb;\n      }\n\n      &.active {\n        color: #2563eb;\n        font-weight: 600;\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          bottom: -12px;\n          left: 0;\n          width: 100%;\n          height: 2px;\n          background-color: #2563eb;\n        }\n      }\n    }\n  }\n\n  .diagnostic-section {\n    .section-header {\n      margin-bottom: 30px;\n      text-align: center;\n\n      h2 {\n        font-size: 24px;\n        font-weight: 600;\n        color: #1e293b;\n        margin-bottom: 8px;\n      }\n\n      p {\n        font-size: 16px;\n        color: #64748b;\n      }\n    }\n  }\n\n  // Topics Near Mastery styles\n  .topics-near-mastery {\n    .topics-chart-container {\n      display: flex;\n      justify-content: center;\n      margin-bottom: 40px;\n    }\n\n    .topic-card-content {\n      .topic-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 12px;\n\n        h3 {\n          font-size: 16px;\n          font-weight: 600;\n          margin: 0;\n        }\n\n        .topic-score {\n          font-size: 14px;\n          font-weight: 500;\n          color: #2563eb;\n        }\n      }\n\n      .resource-dropdown {\n        width: 100%;\n        text-align: left;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 8px 12px;\n        background-color: #f8fafc;\n        border: 1px solid #e2e8f0;\n        border-radius: 4px;\n        font-size: 14px;\n        color: #1e293b;\n\n        &:hover {\n          background-color: #f1f5f9;\n        }\n      }\n    }\n  }\n\n  // Recommendations styles\n  .recommendations {\n    .recommendations-list {\n      display: grid;\n      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n      gap: 20px;\n      margin-top: 30px;\n\n      .recommendation-item {\n        background-color: #f8fafc;\n        border-radius: 8px;\n        padding: 20px;\n        border: 1px solid #e2e8f0;\n\n        .recommendation-info {\n          margin-bottom: 15px;\n\n          .topic-name {\n            font-size: 14px;\n            color: #64748b;\n            margin-bottom: 8px;\n          }\n\n          .resource-name {\n            font-size: 16px;\n            font-weight: 600;\n            color: #1e293b;\n            margin-bottom: 4px;\n          }\n\n          .priority-badge {\n            display: inline-block;\n            padding: 4px 8px;\n            border-radius: 4px;\n            font-size: 12px;\n            font-weight: 500;\n\n            &.high {\n              background-color: #fee2e2;\n              color: #dc2626;\n            }\n\n            &.medium {\n              background-color: #fef3c7;\n              color: #d97706;\n            }\n\n            &.low {\n              background-color: #dcfce7;\n              color: #16a34a;\n            }\n          }\n        }\n\n        .recommendation-progress {\n          margin-bottom: 15px;\n\n          .progress-bar {\n            height: 6px;\n            background-color: #e2e8f0;\n            border-radius: 3px;\n            overflow: hidden;\n            margin-bottom: 4px;\n\n            .progress-fill {\n              height: 100%;\n              background-color: #2563eb;\n              transition: width 0.3s ease;\n            }\n          }\n\n          .progress-text {\n            font-size: 12px;\n            color: #64748b;\n          }\n        }\n      }\n    }\n  }\n\n  // Growth Progress styles\n  .growth-progress {\n    .growth-progress-content {\n      display: flex;\n      gap: 40px;\n      align-items: flex-start;\n\n      .pyramid-chart {\n        flex: 1;\n        max-width: 400px;\n      }\n\n      .topics-details {\n        flex: 2;\n        display: flex;\n        flex-direction: column;\n        gap: 30px;\n\n        .topics-section {\n          background-color: #f8fafc;\n          border-radius: 8px;\n          padding: 20px;\n          border: 1px solid #e2e8f0;\n\n          h3 {\n            font-size: 18px;\n            font-weight: 600;\n            color: #1e293b;\n            margin-bottom: 15px;\n          }\n\n          .topics-list {\n            display: grid;\n            grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n            gap: 12px;\n\n            .topic-item {\n              display: flex;\n              justify-content: space-between;\n              align-items: center;\n              padding: 8px 12px;\n              background-color: white;\n              border-radius: 4px;\n              border: 1px solid #e2e8f0;\n\n              .topic-name {\n                font-size: 14px;\n                color: #1e293b;\n              }\n\n              .status-badge {\n                font-size: 12px;\n                font-weight: 500;\n                padding: 2px 8px;\n                border-radius: 4px;\n\n                &.basic {\n                  background-color: #fee2e2;\n                  color: #dc2626;\n                }\n\n                &.inProgress {\n                  background-color: #fef3c7;\n                  color: #d97706;\n                }\n\n                &.mastered {\n                  background-color: #dcfce7;\n                  color: #16a34a;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// Resource Dropdown Menu Styles\n.dropdown-menu {\n  padding: 6px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  z-index: 1050;\n  position: absolute;\n  width: 100%;\n  margin-top: 4px;\n  background: white;\n  transform: none !important;\n  min-width: 200px;\n  max-width: 300px;\n\n  .dropdown-item {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 8px 12px;\n    border-radius: 6px;\n    color: #4a5568;\n    font-size: 13px;\n    white-space: normal;\n    word-wrap: break-word;\n    position: relative;\n    line-height: 1.4;\n    min-height: 40px;\n\n    &:hover {\n      background: #f7fafc;\n      color: #564ffd;\n    }\n\n    .resource-icon {\n      color: #564ffd;\n      width: 14px;\n      height: 14px;\n      flex-shrink: 0;\n      margin-top: 2px;\n    }\n\n    .resource-name {\n      flex: 1;\n      min-width: 0;\n    }\n\n    // Add tooltip on hover for very long names\n    // &:hover::after {\n    //   content: attr(data-full-text);\n    //   position: absolute;\n    //   left: 0;\n    //   top: 100%;\n    //   background: #2d3748;\n    //   color: white;\n    //   padding: 6px 10px;\n    //   border-radius: 4px;\n    //   font-size: 12px;\n    //   white-space: normal;\n    //   max-width: 250px;\n    //   z-index: 10000;\n    //   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    //   margin-top: 4px;\n    //   display: none; // Only show if needed\n    // }\n\n    // &:hover[data-full-text]:not([data-full-text=\"\"])::after {\n    //   display: block;\n    // }\n  }\n}\n\n.resource-dropdown {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 12px;\n  font-size: 14px;\n  background-color: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  color: #4a5568;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  &:hover {\n    background-color: #edf2f7;\n  }\n\n  .dropdown-toggle-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n\n    .dropdown-text {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n}\n\n// Update Bootstrap dropdown styles\n.dropdown {\n  position: relative;\n\n  &.show {\n    z-index: 1050;\n  }\n\n  .dropdown-toggle {\n    &::after {\n      display: none;\n    }\n  }\n}\n\n// Add styles for foreignObject to ensure proper stacking\nforeignObject {\n  overflow: visible !important;\n  pointer-events: all;\n}\n\n// Responsive Styles\n@media (max-width: 1024px) {\n  .diagnostic-container {\n    padding: 16px;\n\n    .topics-near-mastery {\n      .topics-chart-container {\n        margin-top: 24px;\n      }\n\n      .topics-chart {\n        height: 400px;\n      }\n    }\n\n    .recommendations {\n      .recommendation-item {\n        flex-direction: column;\n        gap: 16px;\n        text-align: center;\n\n        .recommendation-info {\n          text-align: center;\n        }\n\n        .recommendation-progress {\n          margin: 16px 0;\n        }\n      }\n    }\n  }\n}\n\n// Growth Progress Styles\n.growth-progress-container {\n  padding: 20px;\n\n  .growth-progress-header {\n    margin-bottom: 32px;\n\n    h2 {\n      font-size: 24px;\n      font-weight: 600;\n      color: #2d3748;\n      margin-bottom: 8px;\n    }\n\n    p {\n      color: #718096;\n      font-size: 16px;\n    }\n  }\n\n  .growth-progress-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 32px;\n  }\n\n  .pyramid-chart {\n    width: 100%;\n    max-width: 600px;\n    margin: 0 auto;\n    padding: 20px;\n    background: white;\n    border-radius: 16px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n\n    svg {\n      width: 100%;\n      height: auto;\n    }\n  }\n\n  .topics-details {\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n    margin-top: 32px;\n\n    .topics-section {\n      background: white;\n      border-radius: 12px;\n      padding: 20px;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n\n      h3 {\n        font-size: 18px;\n        font-weight: 600;\n        margin-bottom: 16px;\n        padding-bottom: 12px;\n        border-bottom: 1px solid #e2e8f0;\n\n        &.mastered {\n          color: #4caf50;\n        }\n\n        &.in-progress {\n          color: #ffa726;\n        }\n\n        &.basic {\n          color: #ef5350;\n        }\n      }\n\n      .topics-list {\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n        max-height: 300px;\n        overflow-y: auto;\n\n        &::-webkit-scrollbar {\n          width: 6px;\n        }\n\n        &::-webkit-scrollbar-track {\n          background: #f1f1f1;\n          border-radius: 3px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n          background: #cbd5e0;\n          border-radius: 3px;\n        }\n      }\n\n      .topic-item {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 8px 12px;\n        background: #f7fafc;\n        border-radius: 6px;\n        transition: transform 0.2s ease;\n\n        &:hover {\n          transform: translateX(4px);\n        }\n\n        .topic-name {\n          font-size: 14px;\n          color: #4a5568;\n          flex: 1;\n          margin-right: 12px;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n\n        .status-badge {\n          padding: 4px 8px;\n          border-radius: 4px;\n          font-size: 12px;\n          font-weight: 500;\n          white-space: nowrap;\n\n          &.mastered {\n            background: #4caf50;\n            color: white;\n          }\n\n          &.in-progress {\n            background: #ffa726;\n            color: white;\n          }\n\n          &.basic {\n            background: #ef5350;\n            color: white;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Responsive styles for Growth Progress\n@media (max-width: 1024px) {\n  .growth-progress-container {\n    .topics-details {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n}\n\n@media (max-width: 1024px) {\n  .growth-progress-container {\n    padding: 16px;\n\n    .topics-details {\n      grid-template-columns: 1fr;\n    }\n\n    .pyramid-chart {\n      padding: 16px;\n    }\n  }\n}\n\n// Filter Dropdown Styles\n.filter-dropdown {\n  position: relative;\n  display: inline-block;\n\n  .filter-button {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 16px;\n    background: #fff;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    color: #333;\n    font-size: 14px;\n    transition: all 0.2s ease;\n    width: 100%;\n\n    &:hover {\n      background: #f8f9fa;\n      border-color: #dee2e6;\n    }\n\n    .filter-icon {\n      font-size: 16px;\n      color: #666;\n    }\n\n    .filter-text {\n      font-weight: 500;\n    }\n\n    .filter-badge {\n      background: #e3f2fd;\n      color: #1976d2;\n      padding: 2px 8px;\n      border-radius: 12px;\n      font-size: 12px;\n      font-weight: 600;\n    }\n  }\n\n  .filter-menu {\n    position: absolute;\n    left: 0;\n    top: 100%;\n    padding: 12px;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    min-width: 250px;\n    background: white;\n    z-index: 1000;\n    margin-top: 8px;\n\n    .filter-menu-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 12px;\n\n      .filter-menu-title {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        color: #333;\n        font-weight: 600;\n\n        .filter-menu-icon {\n          font-size: 16px;\n          color: #666;\n        }\n\n        h5 {\n          margin: 0;\n          font-size: 14px;\n        }\n      }\n\n      .clear-all {\n        color: #1976d2;\n        font-size: 12px;\n        padding: 4px 8px;\n        border-radius: 4px;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background: #e3f2fd;\n        }\n      }\n    }\n\n    .filter-menu-divider {\n      height: 1px;\n      background: #e0e0e0;\n      margin: 8px 0;\n    }\n\n    .filter-options {\n      max-height: 300px;\n      overflow-y: auto;\n      padding-right: 4px;\n\n      &::-webkit-scrollbar {\n        width: 6px;\n      }\n\n      &::-webkit-scrollbar-track {\n        background: #f1f1f1;\n        border-radius: 3px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background: #ccc;\n        border-radius: 3px;\n\n        &:hover {\n          background: #999;\n        }\n      }\n\n      .filter-option {\n        padding: 8px 0;\n\n        .custom-checkbox {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          cursor: pointer;\n          user-select: none;\n\n          input[type=\"checkbox\"] {\n            width: 16px;\n            height: 16px;\n            margin: 0;\n            cursor: pointer;\n          }\n\n          label {\n            margin: 0;\n            font-size: 14px;\n            color: #333;\n            cursor: pointer;\n          }\n\n          &:hover {\n            label {\n              color: #1976d2;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.topic-card-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  gap: 8px;\n\n  .topic-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 8px;\n\n    .topic-name {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 600;\n      color: #2d3748;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      max-width: 150px;\n      cursor: default;\n    }\n\n    .topic-score {\n      font-size: 16px;\n      font-weight: 600;\n      color: #4a5568;\n      white-space: nowrap;\n    }\n  }\n\n  .resource-dropdown {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 6px 12px;\n    font-size: 14px;\n    background-color: #f7fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 4px;\n    color: #4a5568;\n\n    &:hover {\n      background-color: #edf2f7;\n    }\n  }\n}\n\n.resource-dropdown-menu {\n  padding: 0;\n\n  .scrollable-menu {\n    max-height: 200px; // This will show approximately 4 items\n    overflow-y: auto;\n\n    // Custom scrollbar styles\n    &::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: #f1f1f1;\n      border-radius: 3px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #888;\n      border-radius: 3px;\n\n      &:hover {\n        background: #555;\n      }\n    }\n  }\n\n  .dropdown-item {\n    padding: 8px 16px;\n\n    &:hover {\n      background-color: #f8f9fa;\n    }\n\n    .resource-name {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n}\n\n/* PDF Report Styles */\n.pdf-report {\n  position: fixed;\n  top: -9999px;\n  left: -9999px;\n  width: 210mm;\n  background-color: white;\n  padding: 20px;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none;\n\n  // Only show when loading is true\n  &.generating {\n    position: relative;\n    top: auto;\n    left: auto;\n    z-index: 1;\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  .pdf-section {\n    margin-bottom: 30px;\n\n    .pdf-section-title {\n      color: #1f2937;\n      font-size: 24px;\n      font-weight: 600;\n      margin-bottom: 20px;\n      padding-bottom: 10px;\n      border-bottom: 2px solid #e5e7eb;\n    }\n  }\n\n  .pdf-scores-container {\n    max-height: none !important;\n    overflow: visible !important;\n\n    .scores-list {\n      max-height: none !important;\n      overflow: visible !important;\n      height: auto !important;\n      display: block !important;\n    }\n\n    .excel-grid {\n      max-height: none !important;\n      overflow: visible !important;\n      height: auto !important;\n      display: block !important;\n    }\n\n    .grid-row {\n      display: grid;\n      grid-template-columns: 2fr 1fr;\n      border-bottom: 1px solid #dee2e6;\n      transition: background-color 0.2s;\n\n      &:hover {\n        background-color: #f8f9fa;\n      }\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n\n    .grid-cell {\n      padding: 12px 16px;\n      font-size: 14px;\n      color: #495057;\n      border-right: 1px solid #dee2e6;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n\n      &:last-child {\n        border-right: none;\n        text-align: right;\n        font-weight: 500;\n      }\n    }\n  }\n\n  .page-break {\n    page-break-after: always;\n    height: 0;\n    margin: 0;\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
